const CHANGE_WORKKARD_OWNER_ERROR_VALIDATION_MESSAGE  = {
    400 : 'This action cannot be performed since the item(s) you have selected may have already been changed by another user or you may not have the required permission(s).',
    405 : 'This is not valid action on selected records'
};

const CHANGE_ACTIVITY_OWNER_ERROR_VALIDATION_MESSAGE  = {
    400 : 'This action cannot be performed since the item(s) you have selected may have already been changed by another user or you may not have the required permission(s).',
    405 : 'This is not valid action on selected records'
};

export {
    CHANGE_WORKKARD_OWNER_ERROR_VALIDATION_MESSAGE,
    CHANGE_ACTIVITY_OWNER_ERROR_VALIDATION_MESSAGE
}